import { Button, ButtonProps } from '@chakra-ui/react';
import { useContext } from 'react';
import MerchantContext from '../contexts/MerchantContext';

const CustomButton = (props: ButtonProps) => {
  const { merchant } = useContext(MerchantContext);

  return (
    <Button
      {...props}
      variant="main"
      backgroundColor={merchant?.customButton?.backgroundColor}
      color={merchant?.customButton?.color}
    />
  );
};

export default CustomButton;
